// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P3vX","clinicsSelect":"styles_clinicsSelect__2HGIU"};